import { type ReactNode } from 'react';
import ExpanderPanel from '@rio-cloud/rio-uikit/ExpanderPanel';

interface CollapsibleSectionProps {
    title: string;
    icon?: string;
    children: ReactNode;
    defaultOpen?: boolean;
}

const CollapsibleSection = ({ title, icon, children, defaultOpen = false }: CollapsibleSectionProps) => {
    const titleContent = icon ? (
        <span className="display-flex align-items-center gap-5">
            <span className={`rioglyph ${icon} text-size-16`} />
            <span>{title}</span>
        </span>
    ) : (
        title
    );

    return (
        <>
            <hr className="margin-0" style={{ borderColor: '#ccc' }} />
            <ExpanderPanel title={titleContent} open={defaultOpen} bsStyle="blank" className="margin-bottom-0">
                {children}
            </ExpanderPanel>
        </>
    );
};

export default CollapsibleSection;
